import React from "react";

export default function Module_5() {
    return (
        <>
            <div className="py-4">
                <h2 className="text-uppercase text-center mb-4">
                    Customer Reviews
                </h2>
                <div className="row">
                    <div className="col-md-6">
                        <figure className="mx-auto quote">
                            <q className="lead" style={{ height: "80%" }}>
                                We enjoy working with DSSL, as they provide
                                exceptional customer service and the highest
                                quality LED products. We will continue to
                                specify them on future projects.
                            </q>
                            <figcaption>
                                <strong> Dan Pitcher</strong>, Design Build
                                Lighting
                            </figcaption>
                        </figure>
                    </div>
                    <div className="col-md-6">
                        <figure className="mx-auto quote">
                            <q className="lead" style={{ height: "80%" }}>
                                DSSL customer service is top notch! Always
                                answers quickly and if ever there is an issue,
                                they handle it quickly!
                            </q>
                            <figcaption>
                                <strong> Deborah Vance</strong>, Smart Lighting
                                Solutions
                            </figcaption>
                        </figure>
                    </div>
                    <div className="col-md-6">
                        <figure className="mx-auto quote">
                            <q className="lead" style={{ height: "80%" }}>
                                DSSL has solutions when the others don't, and
                                they are a great price and product each time!
                            </q>
                            <figcaption>
                                <strong> Aaron Lyddon</strong>, DECO Lights
                            </figcaption>
                        </figure>
                    </div>
                    <div className="col-md-6">
                        <figure className="mx-auto quote">
                            <q className="lead" style={{ height: "80%" }}>
                                Great company with quality products that you can
                                count on. Customer service is second to none!
                            </q>
                            <figcaption>
                                <strong> Brittany Rogers</strong>, Smart
                                Lighting Solutions
                            </figcaption>
                        </figure>
                    </div>
                </div>
            </div>
        </>
    );
}
